import { supabase } from '@/lib/supabase';

interface ResendProjectMemberInviteInput {
  inviteId: number;
}

export const resendProjectMemberInvite = async ({
  inviteId,
}: ResendProjectMemberInviteInput) => {
  const { data, error } = await supabase.rpc(
    'resend_project_member_invitation',
    {
      p_invitation_id: inviteId,
    },
  );
  if (error) throw error;
  return data;
};
